import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DateWrapper } from "./styles/SelectDateStyle";
import { InputDateWrapper, InputDateButton } from "./styles/DateInputStyle";

const DateInput = ({ label, ButtonText }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const datepickerRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleDateClick = () => {
    setShowDatePicker(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
  };

  const handleClickOutside = (event) => {
    if (
      datepickerRef.current &&
      !datepickerRef.current.contains(event.target)
    ) {
      setShowDatePicker(false);
    }
  };

  return (
    <>
      <InputDateWrapper>
        <label>{label}</label>
        <InputDateButton onClick={handleDateClick}>
          {ButtonText}
        </InputDateButton>
        {showDatePicker && (
          <DateWrapper className="customer__dateinputs" ref={datepickerRef}>
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              showPopperArrow={false}
              inline
            />
          </DateWrapper>
        )}
      </InputDateWrapper>
    </>
  );
};

export default DateInput;
